if (!customElements.get('edvi-pdp-socials')) {
  customElements.define('edvi-pdp-socials', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.viewport = this.querySelector('[data-socials-viewport]');
      this.cards = [...this.querySelectorAll('[data-socials-card]')];
      this.status = this.querySelector('[data-socials-status]');
      this.index = Math.min(2, this.cards.length - 1);
      if (!this.viewport || this.cards.length < 2) return;
      this.querySelector('[data-socials-previous]').addEventListener('click', () => this.move(-1), { signal });
      this.querySelector('[data-socials-next]').addEventListener('click', () => this.move(1), { signal });
      this.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }, { signal });
      this.viewport.addEventListener('pointerdown', event => {
        if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
        this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY };
        this.viewport.setPointerCapture(event.pointerId);
      }, { signal });
      this.viewport.addEventListener('pointerup', event => {
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        const dx = event.clientX - this.pointer.x;
        const dy = event.clientY - this.pointer.y;
        this.pointer = null;
        if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) this.move(dx < 0 ? 1 : -1);
      }, { signal });
      this.viewport.addEventListener('pointercancel', () => { this.pointer = null; }, { signal });
      this.resizeObserver = new ResizeObserver(() => this.layout());
      this.resizeObserver.observe(this.viewport);
      this.layout();
      this.setAttribute('data-ready', '');
      this.querySelectorAll('.edvi-pdp-socials__arrow').forEach(button => { button.hidden = false; });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.repositionFrame);
      this.controller = null;
    }

    layout() {
      const width = this.viewport.clientWidth;
      this.mobile = matchMedia('(max-width: 699px)').matches;
      this.cardWidth = this.mobile ? (width - 4) / 1.5 - 4 : (width - 44) / 5;
      this.step = this.cardWidth + 10;
      this.style.setProperty('--socials-card-width', `${this.cardWidth}px`);
      this.style.setProperty('--socials-height', `${this.cardWidth * 35 / 24 + 4}px`);
      this.render(false);
    }

    move(direction) {
      this.index = (this.index + direction + this.cards.length) % this.cards.length;
      this.render(true);
    }

    render(announce) {
      const count = this.cards.length;
      this.cards.forEach((card, index) => {
        let offset = (index - this.index + count) % count;
        if (offset > count / 2) offset -= count;
        const previous = Number(card.dataset.offset);
        const wrapping = Number.isFinite(previous) && Math.abs(previous - offset) > 1;
        card.toggleAttribute('data-reposition', wrapping);
        card.dataset.offset = String(offset);
        const distance = Math.abs(offset);
        card.style.setProperty('--socials-x', `${offset * this.step}px`);
        card.style.setProperty('--socials-scale', String(1 - distance * .104));
        card.style.setProperty('--socials-opacity', distance <= 2 ? '1' : '0');
        card.style.setProperty('--socials-z', String(4 - distance));
        card.setAttribute('aria-hidden', String(distance > (this.mobile ? 1 : 2)));
        card.toggleAttribute('data-current', offset === 0);
      });
      if (announce) this.status.textContent = this.status.dataset.template.replace('[index]', String(this.index + 1));
      cancelAnimationFrame(this.repositionFrame);
      this.repositionFrame = requestAnimationFrame(() => {
        this.repositionFrame = requestAnimationFrame(() => {
          this.cards.forEach(card => card.removeAttribute('data-reposition'));
        });
      });
    }
  });
}
